import * as Yup from 'yup';

export const PASSWORD_REGEX = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,128}$/;
export const PASSWORD_MSG = "Password must be 8-128 characters and include at least one uppercase letter, one lowercase letter, one number, and one special character (@$!%*?&)";

export const passwordSchema = Yup.string()
    .required("Required")
    .matches(PASSWORD_REGEX, PASSWORD_MSG);

export const confirmPasswordSchema = Yup.string()
    .required("Required")
    .oneOf([Yup.ref('password'), null], "Passwords must match");

export function getPasswordStrength(password) {
    if (!password) return { score: 0, label: '', color: '' };
    let score = 0;
    if (password.length >= 8) score++;
    if (/[A-Z]/.test(password)) score++;
    if (/[a-z]/.test(password)) score++;
    if (/\d/.test(password)) score++;
    if (/[@$!%*?&]/.test(password)) score++;

    if (score <= 2) return { score, label: 'Weak', color: '#dc3545' };
    if (score === 3) return { score, label: 'Fair', color: '#fd7e14' };
    if (score === 4) return { score, label: 'Good', color: '#ffc107' };
    return { score, label: 'Strong', color: '#198754' };
}
